/**
 * External enrollment URL — the single source of truth for every
 * "Join Now" / "Start Now" / "Start Membership" / pricing-card CTA on
 * the site. Owned by Fitness Pro Galt's existing MyMemberAccount
 * group; opens in a new tab so the marketing site stays in the user's
 * back-stack and their scroll position is preserved on return.
 *
 * Important: this is the ONLY place this URL should live. If the
 * group/offer ID ever changes, update it here and every CTA across
 * the site is updated automatically.
 */
export const ENROLLMENT_URL =
  'https://www.mymemberaccount.com/member-enrollment/2440/group/2604?view=offer';

/**
 * Open the enrollment portal in a new tab with hardened opener/referrer
 * isolation. We use a safe set of `noopener,noreferrer` so the popup
 * cannot reach back into our window via `window.opener` (Tabnabbing
 * defence) and so the third-party host doesn't see the source page
 * referrer (matches our existing privacy posture).
 *
 * @param {object} [opts]
 * @param {string} [opts.plan] - optional plan slug appended as ?plan= for
 *   the enrollment portal's analytics. The MyMemberAccount portal
 *   ignores unknown query params so this is safe even if the field is
 *   not consumed today.
 */
export function openEnrollment(opts = {}) {
  if (typeof window === 'undefined') return;
  let url = ENROLLMENT_URL;
  if (opts.plan) {
    // ENROLLMENT_URL already has `?view=offer` — append additional params.
    url = `${ENROLLMENT_URL}&plan=${encodeURIComponent(opts.plan)}`;
  }
  try {
    window.open(url, '_blank', 'noopener,noreferrer');
  } catch (_e) {
    // Fallback if popup blocked — same-tab navigation. Browsers will
    // still preserve back-button position via history.
    window.location.href = url;
  }
}
